/**
 * 
 */
class WMUWCAddress {

	/**
	 * 
	 * @type HTMLElement
	 */
	contextElement = null;

	/**
	 * 
	 * @type Object
	 */
	countryLocale = null;

	/**
	 * 
	 * @type HTMLElement
	 */
	fieldCountryElement = null;

	/**
	 * 
	 * @type String
	 */
	fieldCountrySelector = '';

	/**
	 * 
	 * @type Object
	 */
	fieldPostcodeDefaults = null;

	/**
	 * 
	 * @type HTMLElement
	 */
	fieldPostcodeElement = null;

	/**
	 * 
	 * @type String
	 */
	fieldPostcodeSelector = '';

	/**
	 * 
	 * @type Object
	 */
	fieldStateDefaults = null;

	/**
	 * 
	 * @type HTMLElement
	 */
	fieldStateElement = null;

	/**
	 * 
	 * @type String
	 */
	fieldStateSelector = '';

	/**
	 * 
	 * @param {Object} args Expected properties : contextElement (HTML element where to find the fields), countryLocale (field settings from woocommerce)
	 */
	constructor( args )
	{
		this.contextElement = args.contextElement;
		this.countryLocale = args.countryLocale;
		this.fieldCountrySelector = args.fieldCountrySelector;
		this.fieldPostcodeDefaults = args.fieldPostcodeDefaults;
		this.fieldPostcodeSelector = args.fieldPostcodeSelector;
		this.fieldStateDefaults = args.fieldStateDefaults;
		this.fieldStateSelector = args.fieldStateSelector;

		/**
		 * @todo Mettre en place un check spécifique si un wmu-field encadre le field et on masquera en fonction
		 */
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onCountryChange = this.onCountryChange.bind( this );

		this.fieldCountryElement = this.contextElement.querySelector( this.fieldCountrySelector );
		this.fieldPostcodeElement = this.contextElement.querySelector( this.fieldPostcodeSelector );
		this.fieldStateElement = this.contextElement.querySelector( this.fieldStateSelector );

		if ( ! this.fieldCountryElement || ! this.fieldPostcodeElement || ! this.fieldStateElement )
		{
			console.error( 'WMUWCAddress | init | Some required elements are not found' );
			return;
		}

		this.fieldPostcodeElement.wmuField = this.fieldPostcodeElement.closest( '.wmu-field' );
		this.fieldPostcodeElement.wmuFieldLabel = this.contextElement.querySelector( `label[for="${this.fieldPostcodeElement.id}"]` );
		this.fieldStateElement.wmuField = this.fieldStateElement.closest( '.wmu-field' );
		this.fieldStateElement.wmuFieldLabel = this.contextElement.querySelector( `label[for="${this.fieldStateElement.id}"]` );

		this.fieldCountryElement.addEventListener( 'change', this.onCountryChange );
		
		if ( this.fieldCountryElement.value )
		{
			this.applyCountrySettings( this.fieldCountryElement.value );
		}
	}

	/**
	 * 
	 * @param {String} countryCode 
	 */
	applyCountrySettings( countryCode )
	{
		const countrySettings = this.countryLocale[ countryCode ];
		const postcodeRequired = ( countrySettings && countrySettings.postcode && undefined !== countrySettings.postcode.required ) ? countrySettings.postcode.required : this.fieldPostcodeDefaults.required;
		const postcodeHidden = ( countrySettings && countrySettings.postcode && undefined !== countrySettings.postcode.hidden ) ? countrySettings.postcode.hidden : this.fieldPostcodeDefaults.hidden;
		const postcodeLabel = ( countrySettings && countrySettings.postcode && undefined !== countrySettings.postcode.label ) ? countrySettings.postcode.label : this.fieldPostcodeDefaults.label;
		const stateRequired = ( countrySettings && countrySettings.state && undefined !== countrySettings.state.required ) ? countrySettings.state.required : this.fieldStateDefaults.required;
		const stateHidden = ( countrySettings && countrySettings.state && undefined !== countrySettings.state.hidden ) ? countrySettings.state.hidden : this.fieldStateDefaults.hidden;
		const stateLabel = ( countrySettings && countrySettings.state && undefined !== countrySettings.state.label ) ? countrySettings.state.label : this.fieldStateDefaults.label;

		/**
		 * Postcode
		 */
		if ( postcodeRequired )
		{
			this.fieldPostcodeElement.setAttribute( 'required', 'required' );

			if ( this.fieldPostcodeElement.wmuField )
			{
				this.fieldPostcodeElement.wmuField.classList.add( 'required' );
			}
		}
		else
		{
			this.fieldPostcodeElement.removeAttribute( 'required' );

			if ( this.fieldPostcodeElement.wmuField )
			{
				this.fieldPostcodeElement.wmuField.classList.remove( 'required' );
			}
		}

		if ( postcodeHidden )
		{
			if ( this.fieldPostcodeElement.wmuField )
			{
				this.fieldPostcodeElement.wmuField.style.display = 'none';
			}
			else
			{
				this.fieldPostcodeElement.style.display = 'none';
			}
		}
		else
		{
			if ( this.fieldPostcodeElement.wmuField )
			{
				this.fieldPostcodeElement.wmuField.style.display = null;
			}
			else
			{
				this.fieldPostcodeElement.style.display = null;
			}
		}

		if ( this.fieldPostcodeElement.wmuFieldLabel )
		{
			this.fieldPostcodeElement.wmuFieldLabel.innerHTML = postcodeLabel;
		}

		/**
		 * State
		 */
		if ( stateRequired )
		{
			this.fieldStateElement.setAttribute( 'required', 'required' );

			if ( this.fieldStateElement.wmuField )
			{
				this.fieldStateElement.wmuField.classList.add( 'required' );
			}
		}
		else
		{
			this.fieldStateElement.removeAttribute( 'required' );

			if ( this.fieldStateElement.wmuField )
			{
				this.fieldStateElement.wmuField.classList.remove( 'required' );
			}
		}

		if ( stateHidden )
		{
			if ( this.fieldStateElement.wmuField )
			{
				this.fieldStateElement.wmuField.style.display = 'none';
			}
			else
			{
				this.fieldStateElement.style.display = 'none';
			}
		}
		else
		{
			if ( this.fieldStateElement.wmuField )
			{
				this.fieldStateElement.wmuField.style.display = null;
			}
			else
			{
				this.fieldStateElement.style.display = null;
			}
		}

		if ( this.fieldStateElement.wmuFieldLabel )
		{
			this.fieldStateElement.wmuFieldLabel.innerHTML = stateLabel;
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onCountryChange( event )
	{
		this.applyCountrySettings( this.fieldCountryElement.value );
	}

}

export default WMUWCAddress;